module.exports = __webpack_public_path__ + "img/cancel.6946f468.svg";